import React from 'react'

import { CatalogItemType } from 'models'

import { transformCatalogItemType } from 'shared/pipes'

import classes from './CatalogItemLabel.module.scss'

type Props = {
  isPremiereOrLeader?: 1 | 2
  type: number
}
export const CatalogItemLabel = ({
  isPremiereOrLeader,
  type,
}: Props): JSX.Element => {
  if (isPremiereOrLeader && [1, 2].includes(isPremiereOrLeader)) {
    return (
      <div className={classes.new}>
        {isPremiereOrLeader === 1 ? 'Лидер просмотров' : 'Премьера'}
      </div>
    )
  }

  const withFilmBg = [
    CatalogItemType.Film,
    CatalogItemType.Documentary,
    CatalogItemType.FeatureFilm,
  ].includes(type)

  return (
    <div className={withFilmBg ? classes.Film : classes.Serial}>
      {transformCatalogItemType(type)}
    </div>
  )
}
